/**
 * Logic Necessary for the CPE
 * List View
 * Author: Imarc 2019
 */

import classToggle from '@inkwell/scripts/modules/classtoggle';
import convertToLocalTime from '@inkwell/scripts/modules/datetimeHandler';


const options = document.querySelector('[data-options-details]');
const resultsFiltersForm = document.querySelector('#results-filters');
const keywordFilter = resultsFiltersForm.querySelector('[name="f[kw]"]');
const keywordMinimumLength = Number.parseInt(
    resultsFiltersForm.dataset.keywordMinimumLength,
    10
);

classToggle({
    elementClass: '.js-group',
    triggerClass: '.js-groupTrigger',
    toggleClass: '-open',
});

const addClearListeners = () => {
    const appliedFiltersElement = document.querySelector('#applied-filters');
    const clearButtons = [...appliedFiltersElement.querySelectorAll('[data-clear]')];

    clearButtons.forEach(button => {
        button.addEventListener(
            'click',
            function applyEventListener(event) {
                event.preventDefault();
                let formElement = resultsFiltersForm.querySelector(
                    `[name="${button.name}"]:not([type="hidden"])`
                );

                if (!formElement) {
                    formElement = resultsFiltersForm.querySelector(
                        `[data-name="${button.name}"]`
                    );
                }

                if ('slimselect' in formElement.dataset) {
                    const option = formElement.querySelector(
                        `option[value="${button.value}"]`
                    );
                    const selectedValues = formElement.slimSelect.selected();
                    const filteredValues = selectedValues.filter(
                        value => value !== button.value
                    );
                    formElement.slimSelect.set(filteredValues);
                    option.removeAttribute('selected');
                    button.remove();
                    resultsFiltersForm.dispatchEvent(new Event('change'));
                    return;
                }

                if ('flatpickr' in formElement.dataset) {
                    const inputWrapper = formElement.closest('.js-dateRange');
                    const dateBefore = inputWrapper.querySelector('.js-dateBefore');
                    const dateAfter = inputWrapper.querySelector('.js-dateAfter');
                    dateBefore.value = null;
                    dateAfter.value = null;
                    formElement.flatpickr.clear();
                    button.remove();
                    resultsFiltersForm.dispatchEvent(new Event('change'));
                    return;
                }

                if (formElement.type === 'checkbox') {
                    const associatedCheckbox = resultsFiltersForm.querySelector(
                        `input[name="${button.name}"][value="${button.value}"]`
                    );
                    associatedCheckbox.checked = false;
                    associatedCheckbox.removeAttribute('checked');
                    button.remove();
                    resultsFiltersForm.dispatchEvent(new Event('change'));
                    return;
                }

                formElement.value = null;

                button.remove();
                resultsFiltersForm.dispatchEvent(new Event('change'));
            },
            false
        );
    });
};

const applyFilterCounts = filterCounts => {
    Object.entries(filterCounts).forEach(([name, filterData]) => {
        const selectElement = document.querySelector(`select[name^="f[${name}]"]`);
        const checkboxes = [...document.querySelectorAll(`[name="f[${name}][]"]`)];

        if (selectElement) {

            if (typeof selectElement.slimSelect != 'undefined') {
                const selected        = selectElement.slimSelect.selected();
                const selectedOptions = [...selectElement.querySelectorAll('option')].filter((option) => {
                    return selected.includes(option.value);
                });

                selectedOptions.forEach(option => {
                    if (!filterData.data.some(item => item.value == option.value)) {
                        filterData.data.push({
                            label: option.innerHTML.replace(/\s+<strong>.*<\/strong>$/, ''),
                            value: option.value,
                            subtotal: 0
                        });
                    }
                });

                selectElement.slimSelect.setData(
                    filterData.data.map(countDataObject => {
                        return {
                            text: `${countDataObject.label} <strong>(${countDataObject.subtotal})</strong>`,
                            value: countDataObject.value,
                            count: countDataObject.subtotal,
                            selected: selected.includes(countDataObject.value),
                            data: {
                                originalName: countDataObject.label
                            }
                        };
                    })
                )
            }

        } else if (checkboxes.length) {
            checkboxes.forEach(checkboxElement => {
                if (typeof filterData.data !== 'undefined') {
                    const associatedCountDataObject = filterData.data.find(
                        ({ value }) => value === checkboxElement.value
                    );

                    const label = checkboxElement.closest('label');

                    if (label) {
                        label.style.display = 'block';
                        const textSpan = label.querySelector('span');

                        if (!('originalText' in label.dataset)) {
                            label.dataset.originalText = textSpan.textContent;
                        }

                        const labelElement = label.querySelector('span');
                        if (typeof associatedCountDataObject !== 'undefined') {
                            labelElement.innerHTML = `${label.dataset.originalText} <strong>(${associatedCountDataObject.subtotal})</strong>`;    
                        } else if (checkboxElement.checked) {
                            labelElement.innerHTML = `${label.dataset.originalText} <strong>(0)</strong>`;
                        } else {
                            label.style.display = 'none';
                        }
                    }
                }
            });
        }
    });
};

addClearListeners();
applyFilterCounts(window.filterCounts);

const addToggleToListItems = () => {
    document.querySelectorAll('[data-cpe-list-item]').forEach(item => {
        item.addEventListener('click', event => {
            event.currentTarget.classList.toggle('-expanded');
        });
    });
};


const applyDateTime = () => {
    document.querySelectorAll('[data-cpe-list-item]').forEach(item => {
        const timeElements = item.querySelectorAll('time');
        timeElements.forEach(convertToLocalTime);
    });
};


addToggleToListItems();

if (options) {
    classToggle({
        elementClass: '[data-options-details]',
        triggerClass: '[data-options-toggle]',
        toggleClass: '-expanded',
    });
}

document.body.addEventListener('htmx:load', ({ detail }) => {
    if (detail.elt.id === 'applied-filters') {
        addClearListeners();
        applyFilterCounts(window.filterCounts);
    }

    if (detail.elt.id === 'results') {
        addToggleToListItems();
        applyDateTime();
    }

    if (detail.elt.id === 'groups') {
        classToggle({
            elementClass: '.js-group',
            triggerClass: '.js-groupTrigger',
            toggleClass: '-open',
        });
    }
});

const hasIncompleteKeyword = target => {
    if (target !== keywordFilter) {
        return false;
    }

    const value = target.value.trim().replace(/\s+/g, ' ');

    return value.length > 0 && value.length < keywordMinimumLength;
};

document.body.addEventListener('htmx:beforeRequest', event => {
    const target = event.detail.requestConfig.triggeringEvent.explicitOriginalTarget;

    if (
        hasIncompleteKeyword(target) ||
        target.hasAttribute('data-clear')
    ) {
        event.preventDefault();
    }
});
